var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDisplaySettings = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15.783,
  height: 15.783,
  viewBox: "0 0 15.783 15.783",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.127 -2.109)",
  stroke: "#348CFD",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 4.348,
  r: 1.739
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.737 4.348h5.673M2.627 4.348h5.63"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 17.41 8.26)"
}, /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(-1 0 0 1 7.79 0)",
  cx: 3.895,
  cy: 1.739,
  r: 1.739
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.783 1.739H5.63M2.152 1.739H0"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 8.261,
  cy: 15.652,
  r: 1.739
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.997 15.652h7.413M2.627 15.652h3.895"
}))));
export { SvgIconDisplaySettings as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-display-settings.svg";